<template>
  <div class="page">
    <ion-grid>
      <ion-row class="row-divider"></ion-row>
      <ion-row class="search-view">
        <ion-col>
          <ion-row align-items-stretch>
            <ion-col size="12" size-md="2">
              <ion-label>Charger ID</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input class="form-input" type="text" id="id" @input="id = $event.target.value"></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Serial No</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="serialNumber"
                  @input="serialNumber = $event.target.value"
                  maxlength="100"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Manufacturer</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="manufacturer"
                  @input="manufacturer = $event.target.value"
                  maxlength="100"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Charger Type</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-select
                  class="form-select select-mobile"
                  :value="chargerType"
                  @ionChange="chargerType = $event.target.value"
                  placeholder="Select Type"
                  interface="action-sheet"
                >
                
                  <ion-select-option
                    v-for="(type, index) in this.types"
                    :key="index"
                    :value="type.id"
                  >{{type.name}}</ion-select-option>
                  <!-- Below code is commented by vinoth 21.05.2025 as per siva sir request not to display charger type instead of charger discription-->
                  <!-- <ion-select-option
                    v-for="(type, index) in this.types"
                    :key="index"
                    :value="type.id"
                  >{{type.id}}</ion-select-option> -->
                </ion-select>

                <select
                  class="input-select select-web"
                  v-model="chargerType"
                  placeholder="Select Type"
                >
                
                  <option
                    v-for="(type, index) in this.types"
                    :key="index"
                    :value="type.id"
                  >{{ type.name }}</option>
                  <!-- Below code is commented by vinoth 21.05.2025 as per siva sir request not to display charger type instead of charger discription-->
                  <!-- <option
                    v-for="(type, index) in this.types"
                    :key="index"
                    :value="type.id"
                  >{{ type.id }}</option> -->

                </select>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Status</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-select
                  class="form-select select-mobile"
                  :value="status"
                  @ionChange="status = $event.target.value"
                  placeholder="Select Status"
                  interface="action-sheet"
                >
                  <ion-select-option
                    v-for="(status, index) in this.statuses"
                    :key="index"
                    :value="status.id"
                  >{{status.name}}</ion-select-option>
                </ion-select>

                <select
                  class="input-select select-web"
                  v-model="status"
                  placeholder="Select Status"
                >
                  <option
                    v-for="(status, index) in this.statuses"
                    :key="index"
                    :value="status.id"
                  >{{ status.name }}</option>
                </select>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <br />
              <ion-button class="btn-search margin-top-10" @click="searchChargers">Search</ion-button>
              <ion-button class="btn-clear margin-top-10" @click="clearFields">
                <ion-icon :icon="refresh"></ion-icon>
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row class="list-view">
        <ion-col>
          <ion-row class="list-head">
            <ion-col size="12" size-md="2">
              <ion-label>Charger ID</ion-label>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Serial No</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Manufacturer</ion-label>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Charger Type</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Status</ion-label>
            </ion-col>
          </ion-row>
          <hr />

          <ion-row class="list-item" v-for="(charger) in this.chargers" :key="charger">
            <ion-col size="12" size-md="2">
              <ion-label class="ext-link" @click="viewCharger(charger.id)">{{charger.id}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="3" style="cursor: pointer;" @click="addSerialNoInFilter(charger.serialNumber)">
              <ion-label>{{charger.serialNumber}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2" style="cursor: pointer;" @click="addManufacturerInFilter(charger.manufacturer)">
              <ion-label>{{charger.manufacturer}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>{{charger.type.id}}</ion-label>
              <!-- Below code is commented by vinoth 21.05.2025 as per siva sir request not to display charger type instead of charger discription-->
              <!-- <ion-label>{{charger.model}}</ion-label> -->
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label
                v-bind:class="[{'active': charger.status.id == 'A'}, {'active': charger.status.id == 'PND'}, {'in-active': charger.status.id == 'RMV'}, {'retired': charger.status.id == 'RET'}, {'installed': charger.status.id == 'INS'}]"
              >{{convertUppercase(charger.status.name)}}</ion-label>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row v-if="norecordsfound">
        <ion-col size="12" class="pagination-info">
          <ion-label class="pagination-info">No records found for the selected filters</ion-label>
        </ion-col>
      </ion-row>
      <ion-row v-else>
        <ion-col size="12" size-md="5">
          <ion-label
            class="pagination-info"
          >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
        </ion-col>
        <ion-col size="12" size-md="7" class="ion-text-right">
          <div class="pagination">
            <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
            <a class="prev disabled" v-else>Prev</a>
            <a
              
              v-for="page in this.pagesList"
              :key="page"
              v-bind:class="{'active': pageNo == page}"
              @click="loadPage(page)"
            >{{page}}</a>
            <a
              
              class="next"
              v-if="this.pageNo < this.totalPages"
              @click="loadPage(pageNo + 1)"
            >Next</a>
            <a class="next disabled" v-else>Next</a>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import { defineComponent } from "vue";
import { refresh } from 'ionicons/icons';
import { EVChargerService } from "../../service/evcstation/charger.service";
import {
  EVCharger,
  EVChargerStatus,
  EVChargerType,
  EVChargerInstallationStatus
} from "../../entity/station/evcharger";
import { migratedTryParseServiceError } from "../../service";
import { ToastUtils } from "../../util/toast-utils";
import { PaginationUtils } from "../../util/pagination-utils";
import { EVCStationService } from "../../service/evcstation/stations.service";


export default defineComponent ({
  name: 'chargers',
  components: {
    IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSelect, IonSelectOption, IonButton, IonIcon, IonSpinner
  },
  data() {
    return {
      refresh,
      loaderTab: true,
      chargers: [],
      statuses: [],
      installationStatuses: [],
      types: [],
      statusModels: [],
      installationStatusModels: [],
      typeModels: [],
      id: "",
      serialNumber: "",
      manufacturer: "",
      chargerType: "",
      installStatus: "",
      status: "",

      norecordsfound: true,
      totalRecords: 0,
      pageRecords: 15,
      pageNo: 1,
      pagesList: [],
      totalPages: 0
    }
  },
  async mounted() {
    try {
      this.types = await new EVChargerService().chargerTypes();
      this.installationStatuses = await new EVCStationService().installationStatuses();
      this.statuses = await new EVChargerService().chargerStatuses();

      this.statusModels = [];
      this.statuses.forEach(status => {
        this.statusModels.push({
          text: status.name,
          value: status.id
        });
      });

      this.installationStatusModels = [];
      this.installationStatuses.forEach(status => {
        this.installationStatusModels.push({
          text: status.name,
          value: status.id
        });
      });

      this.typeModels = [];
      this.types.forEach(type => {
        this.typeModels.push({
          text: type.name,
          value: type.id
        });
      });

      var page = localStorage.getItem('chargerPage');
      if (page) {
        this.pageNo = Number(page);
      }
      var search = localStorage.getItem('chargerSearch');
      if (search) {
        search = JSON.parse(search);
        this.id = search.id;
        this.serialNumber = search.serialNumber;
        this.manufacturer = search.manufacturer;
        document.getElementById("id").value = search.id;
        document.getElementById("serialNumber").value = search.serialNumber;
        document.getElementById("manufacturer").value = search.manufacturer;
        this.chargerType = search.chargerType;
        this.installStatus = search.installStatus;
        this.status = search.status;

        await this.searchChargers();
      }
      this.loaderTab = false;
    } catch(error) {
      this.loaderTab = false;
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    }
    
  },
  methods: {
    
    convertUppercase(value) {
      return value.toUpperCase()
    },
    addCharger() {
      this.$router.push("/admin/chargers/charger");
    },
    viewCharger(chargerId) {
      this.$router.push({
        name: "chargerView",
        params: { chargerId: chargerId }
      });
    },
    addSerialNoInFilter(serialNumber) {
      document.getElementById('serialNumber').value = serialNumber;
      this.serialNumber = serialNumber;
    },
    addManufacturerInFilter(manufacturer) {
      document.getElementById('manufacturer').value = manufacturer;
      this.manufacturer = manufacturer;
    },
    clearFields() {
      this.pageRecords = 15,
      this.pageNo = 1,
      this.id = null;
      this.serialNumber = null;
      this.manufacturer = null;
      document.getElementById("id").value = null;
      document.getElementById("serialNumber").value = null;
      document.getElementById("manufacturer").value = null;
      this.chargerType = null;
      this.installStatus = null;
      this.status = null;

      localStorage.removeItem('chargerSearch');
      localStorage.removeItem('chargerPage');
      this.chargers = [];
      this.norecordsfound = true; //Modified by Swide on 2020-12-16 Bug#3 
    },
    async searchChargers() {
      try {
        // localStorage.setItem('chargerSearch', JSON.stringify({id: this.id, serialNumber: this.serialNumber, manufacturer: this.manufacturer, chargerType: this.chargerType, installStatus: this.installStatus, status: this.status }));
        // if( this.id || this.serialNumber || this.manufacturer || this.chargerType || this.status ) {
        //   this.pageRecords = 5
        //   var page = localStorage.getItem('chargerPage');
        //   if(!page) {
        //       localStorage.removeItem('chargerPage');
        //       this.pageNo = 1
        //   } else {
        //       this.pageNo = page
        //   }
        //   this.pageNo = 1
        // }
        let existingFilterData = JSON.parse(localStorage.getItem("chargerSearch"))
        let searchFilterData = {
          id: this.id,
          serialNumber: this.serialNumber,
          manufacturer: this.manufacturer,
          chargerType: this.chargerType,
          installStatus: this.installStatus,
          status: this.status,
      }
      if(!this.areFiltersEqual(searchFilterData, existingFilterData)) {
         localStorage.setItem("chargerSearch",JSON.stringify(searchFilterData));
          this.pageNo = 1;
          localStorage.setItem('chargerPage', this.pageNo);
        } else {
          let pageNo = localStorage.getItem('chargerPage');
          if(pageNo) {
            this.pageNo = pageNo;
          } else {
            this.pageNo = 1;
          }
        }
       
        // if (
        //   typeof this.status === "undefined" ||
        //   this.status === null ||
        //   this.status === ""
        // ) {
        //   new ToastUtils().presentToast("Select Status");
        // } else {
        this.loaderTab = true;
        let result = await new EVChargerService().chargersAtPageByPaginatedWithSizeMatchingQuery(
            this.pageNo,
            this.pageRecords,
            {
            id: this.id,
            serialNo: this.serialNumber,
            chargerType: new EVChargerType(this.chargerType),
            manufacturer: this.manufacturer,
            effectiveBetween: {
                from: null,
                to: null
            },
            installationStatus: new EVChargerInstallationStatus(
                this.installStatus,
                ""
            ),
            status: new EVChargerStatus(this.status, "")
            }
        );
        this.totalRecords = result.total;
        this.chargers = result.fetched;
        (this.pagesList = new PaginationUtils().getPagesList(
            this.totalRecords,
            this.pageRecords,
            this.pageNo
        )),
            (this.totalPages = new PaginationUtils().getTotalPages(
            this.totalRecords,
            this.pageRecords
            ));
        this.norecordsfound = false;
        this.loaderTab = false;
        new ToastUtils().presentToast("Search completed");
        // }

        
      } catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    },
    areFiltersEqual(a, b) {
      return JSON.stringify(a) === JSON.stringify(b);
    },
    async loadPage(page) {
      localStorage.setItem('chargerPage', page);
      this.loaderTab = true;
      this.pageNo = page;
      this.pagesList = new PaginationUtils().getPagesList(
        this.totalRecords,
        this.pageRecords,
        page
      );

      let result = await new EVChargerService().chargersAtPageByPaginatedWithSizeMatchingQuery(
        this.pageNo,
        this.pageRecords,
        {
        id: this.id,
        serialNo: this.serialNumber,
        chargerType: new EVChargerType(this.chargerType),
        manufacturer: this.manufacturer,
        effectiveBetween: {
          from: null,
          to: null
        },
        installationStatus: new EVChargerInstallationStatus(
          this.installStatus,
          ""
        ),
        status: new EVChargerStatus(this.status, "")
        }
      );
      this.totalRecords = result.total;
      this.chargers = result.fetched;
      this.loaderTab = false;
    }
  }
})
</script>